module.exports = __webpack_public_path__ + "img/nobel.c0fcc92f.png";